import styled, { css } from 'styled-components';
import Blanket from '../common/Blanket';
import { closeContextMenu, useContextMenuSlice } from '../../store/modules/contextMenu';
import { useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;

  background-color: white;

  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);

  padding: 8px 0px;

  ${({ pos }) =>
    pos &&
    css`
      left: ${pos.x}px;
      top: ${pos.y}px;
    `}
  z-index: 1;
`;

const SubMenuWrapper = styled.div``;

export default function ContextMenu() {
  const dispatch = useDispatch();
  const contextMenuSlice = useContextMenuSlice();

  const container = useRef(null);
  const [innerSize, setInnerSize] = useState({ innerWidth: 0, innerHeight: 0 });

  const maxWidth = document.documentElement.offsetWidth;
  const maxHeight = document.documentElement.offsetHeight;
  useEffect(() => {
    if (container.current) {
      setInnerSize({
        innerWidth: container.current.offsetWidth,
        innerHeight: container.current.offsetHeight
      });
    }
  }, [contextMenuSlice.x, contextMenuSlice.y]);

  const x =
    maxWidth < contextMenuSlice.x + innerSize.innerWidth
      ? contextMenuSlice.x - innerSize.innerWidth
      : contextMenuSlice.x;

  const y =
    maxHeight < contextMenuSlice.y + innerSize.innerHeight
      ? contextMenuSlice.y - innerSize.innerHeight
      : contextMenuSlice.y;

  if (!contextMenuSlice.open) return null;
  if (!contextMenuSlice.submenu || contextMenuSlice.submenu.length < 1) return null;

  const onCloseContextMenu = () => {
    dispatch(closeContextMenu());
  };

  return (
    <Wrapper>
      <Blanket
        isTransparentBlanket
        onClick={() => {
          if (contextMenuSlice.onClickBlanket) contextMenuSlice.onClickBlanket();
          onCloseContextMenu();
        }}></Blanket>
      <Container pos={{ x, y }} ref={container}>
        {contextMenuSlice.submenu.map((menu) => (
          <SubMenuWrapper key={menu.props.children} onClick={() => dispatch(closeContextMenu())}>
            {menu}
          </SubMenuWrapper>
        ))}
      </Container>
    </Wrapper>
  );
}
